import { FC } from 'react';

import {
  NotificationEventType,
  NotificationStatus,
} from '~/lib/constants/notifications.constants';

import NotificationAssessment from './Assessment/NotificationAssessment';
import NotificationChat from './Chat/NotificationChat';
import NotificationInquiry from './Inquiry/NotificationInquiry';
import NotificationInquiryReferral from './InquiryReferral/NotificationInquiryReferral';
import NotificationUser from './User/NotificationUser';

interface NotificationCardProps {
  channelName?: string;
  createdAt?: string;
  data?: any;
  dob?: string;
  eventType?: NotificationEventType;
  groupBy: string;
  isRead?: boolean;
  newStatus?: string;
  notificationExternalId?: string;
  oldStatus?: string;
  onUpdateNotification?: (
    notificationExternalIds: Array<string>,
    status: NotificationStatus,
  ) => void;
  patientName?: string;
  relatedNotifications: RelatedNotificationType[];
  type?: string;
}

const NotificationCard = (props: NotificationCardProps) => {
  const { eventType } = props;

  const mapper: Record<NotificationEventType, FC<NotificationCardProps>> = {
    [NotificationEventType.ADDED_TO_CARE_TEAM]: NotificationUser,
    [NotificationEventType.ASSIGNED_INQUIRY]: NotificationInquiry,
    [NotificationEventType.CHAT_MENTION]: NotificationChat,
    [NotificationEventType.CHAT_MESSAGE]: NotificationChat,
    [NotificationEventType.CHAT_REPLY]: NotificationChat,
    [NotificationEventType.COMPLETED_INTAKE_SURVEY]: NotificationAssessment,
    [NotificationEventType.INQUIRY_STATUS_CHANGE]: NotificationInquiry,
    [NotificationEventType.INSURANCE_STATUS_CHANGE]: NotificationInquiry,
    [NotificationEventType.MEDICAL_CLEARANCE_STATUS_CHANGE]:
      NotificationInquiry,
    [NotificationEventType.REMOVED_FROM_CARE_TEAM]: NotificationUser,
    [NotificationEventType.TARGET_ADMIT_DATE_CHANGE]: NotificationInquiry,
    [NotificationEventType.UPDATED_ADMIN_EPISODE]: NotificationInquiryReferral,
    [NotificationEventType.UPDATED_CONTACTS]: NotificationAssessment,
    [NotificationEventType.UPDATED_INSURANCE_STATUS]:
      NotificationInquiryReferral,
    [NotificationEventType.UPDATED_MEDICAL_CLEARANCE_STATUS]:
      NotificationInquiryReferral,
    [NotificationEventType.UPLOADED_INSURANCE_CARD]: NotificationAssessment,
  };

  const CardElement = mapper[eventType];

  return !CardElement ? null : <CardElement {...props} />;
};

export default NotificationCard;
